import { createSlice } from '@reduxjs/toolkit';
import { REACTIONS_INITIAL_STATE } from './reactions.constants';
import {
  getReactionsForModelReducer,
  resetHighlightReactionsDataReducer,
  setHighlightReactionsByIdsReducer,
  setHighlightReactionsReducer,
  setLoadingHighlightReactionsDataReducer,
} from './reactions.reducers';

export const reactionsSlice = createSlice({
  name: 'reactions',
  initialState: REACTIONS_INITIAL_STATE,
  reducers: {
    resetHighlightReactionsData: resetHighlightReactionsDataReducer,
    setHighlightReactions: setHighlightReactionsReducer,
    setHighlightReactionsByIds: setHighlightReactionsByIdsReducer,
    setLoadingHighlightReactionsData: setLoadingHighlightReactionsDataReducer,
  },
  extraReducers: builder => {
    getReactionsForModelReducer(builder);
  },
});

export const {
  resetHighlightReactionsData,
  setHighlightReactions,
  setHighlightReactionsByIds,
  setLoadingHighlightReactionsData,
} = reactionsSlice.actions;

export default reactionsSlice.reducer;
